import React, { useRef } from "react";
import styles from "./DatePicker.module.scss";
import CalendarIcon from "../../../assets/images/svgs/CalendarIcon";

interface DatePickerProps {
  label?: string;
  error?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const DatePicker: React.FC<DatePickerProps> = ({
  label,
  error,
  value,
  onChange,
  className = "",
}) => {
  const dateInputRef = useRef<HTMLInputElement>(null);

  const handleDateSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleIconClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };

  return (
    <div className={`${styles.datePickerWrapper} ${className}`}>
      {label && <label className={styles.label}>{label}</label>}
      <div
        className={`${styles.customDatePicker} ${
          error ? styles.datePickerError : ""
        }`}
      >
        <input
          ref={dateInputRef}
          type="date"
          className={styles.dateInput}
          value={value}
          onChange={handleDateSelect}
        />

        <button
          type="button"
          className={styles.iconButton}
          onClick={handleIconClick}
          aria-label="Open calendar"
        >
          <CalendarIcon />
        </button>
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default DatePicker;
